export default "__VITE_ASSET__IGhYVm1k__"